import React from 'react';

interface ISoundIconProps {
  color?: string;
}
const SoundIcon = ({ color = '#fff' }: ISoundIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-sound"
      width="48"
      height="48"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      fill={color}
    >
      <path d="M26.36 4.76L24.5 6.63a13.26 13.26 0 0 1 0 18.73l1.87 1.88c6.2-6.2 6.2-16.28 0-22.48z" />
      <path d="M22.62 8.5l-1.87 1.88a7.95 7.95 0 0 1 0 11.24l1.87 1.87a10.6 10.6 0 0 0 0-14.98z" />
      <path d="M17 14.13a2.65 2.65 0 0 1 0 3.74l1.87 1.88a5.3 5.3 0 0 0 0-7.5L17 14.13zM14 5v22h-1l-8-7H1v-8h4l8-7z" />
    </svg>
  );
};

export default SoundIcon;
